import { render } from "./sidebar.vue?vue&type=template&id=529a4606"
const script = {}

import exportComponent from "C:\\xampp\\htdocs\\OCL-APPLICATION-2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__